/**
 * 可图 2.0（kling-v2）manifest
 * 数据来源：image.json field_map（旧模型，接口 disable: true）
 * 特点：清晰度分档 1K/2K；比例不分档（顶层 image_ratio，不带真实像素）；参考图上限 4；无参考模式选择
 */
import type { ImageModelConfig } from '../../types';

export const kling2_0: ImageModelConfig = {
  id: '01K1D0WC89GT445VZM5ZQT4KJ5',
  displayName: '可图 2.0',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    resolution: '2K', // 接口 1_resolution.default
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [
    { label: '标清 1K', value: '1K' },
    { label: '高清 2K', value: '2K' },
  ],
  resolutionLabel: '图片质量', // 接口 1_resolution.label

  qualityOptions: [],

  toggles: {},

  limits: {
    maxRefImages: 4, // 接口 field_map.ref_images.max
  },
};
